import { useMutation } from '@tanstack/react-query';
import { useCurrentOrganizationName } from '@/entities/user';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { track } from '@/shared/analytics';
import { useCurrentWorkspaceName } from '@/shared/hooks';
import type { SupportRequest } from '../model/support-request.types';
import { submitSupportRequest } from './support-request.api';

export function useSubmitSupportRequest() {
  const workspaceId = useCurrentWorkspaceId();
  const workspaceName = useCurrentWorkspaceName();
  const organizationName = useCurrentOrganizationName();
  return useMutation({
    mutationFn: (request: SupportRequest) =>
      submitSupportRequest(request, {
        workspaceId: workspaceId ?? '',
        pageUrl: window.location.href,
        workspaceName,
        organizationName,
      }),
    onSuccess: (_data, request) => {
      track('support_request_submitted', {
        request_type: request.type,
        area: request.area,
        is_blocker: request.isBlocker,
        frequency: request.frequency,
        attachment_count: request.attachments.length,
      });
    },
  });
}
